import {Injectable, OnDestroy, Renderer2, RendererFactory2} from '@angular/core';
import {fromEventPattern, Observable, Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {ExternalResourceDialogComponent} from '../components/popupDialog/external-resource-dialog/external-resource-dialog.component';

@Injectable({providedIn: 'root'})
export class DialogListenerService implements OnDestroy {
  private _subscription = Subscription.EMPTY;

  constructor(private rendererFactory2: RendererFactory2, private _dialog: MatDialog) {
  }

  public ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  public init(): void {
    this._subscription = this._createOnClickObservable(this.rendererFactory2.createRenderer(null, null))
    .subscribe((event) => {
      const element = event.target;
      if (element && element['tagName'] === 'A' && event.target['target'] && event.target['target'] === 'modal-dialog') {
        event.preventDefault();
        this._openExternalResourceDialog(event.target['href']);
      }
    });
  }

  private _createOnClickObservable(renderer: Renderer2): Observable<Event> {
    let removeClickEventListener: () => void;
    const createClickEventListener = (handler: (e: Event) => boolean | void) => removeClickEventListener = renderer.listen('document', 'click', handler);
    return fromEventPattern<Event>(createClickEventListener, () => removeClickEventListener());
  }

  private _openExternalResourceDialog(url: string): void {
    const dialogData = {
      externalResourceUrl: url,
    };
    this._dialog.open(ExternalResourceDialogComponent, {
      panelClass: 'lv-external-resource-dialog',
      data: dialogData
    });
  }
}
